document.addEventListener("DOMContentLoaded", () => {
    eggoVideoSlider();
});

function eggoVideoSlider() {
    const slider = new Swiper('.eggo-videos', {
        slidesPerView: "auto",
        centeredSlides:true,
        loop:true,
        breakpoints:{
            320:{
                spaceBetween: 0
            },
            480: {
                spaceBetween:24
            }
        }
    });

    const allVideoContainers = document.querySelectorAll(".eggo-videos__single");
    allVideoContainers.forEach((videoContainer) => {
        videoContainer.addEventListener("click", () => {
            const clickedVideo = videoContainer.querySelector("video");
            if (!clickedVideo) return;
            allVideoContainers.forEach(allVideoContainer => {
                const video = allVideoContainer.querySelector("video");
                if (video === clickedVideo) return;
                video.pause();
                allVideoContainer.classList.remove("playing");
            });
            if (clickedVideo.paused) {
                clickedVideo.play();
                videoContainer.classList.add("playing");
                clickedVideo.muted = false;
                clickedVideo.volume = 0.5;
            } else {
                clickedVideo.pause();
                videoContainer.classList.remove("playing");
            }
        })
    })
}